export const getDoctorsListForDropDown = (doctorsList, searchList) => {
  const list = [];
  if (doctorsList?.length) {
    doctorsList.forEach(item => {
      const {
        AccountKey,
        BranchKey,
        BranchName,
        DoctorNameEnglish,
        EntityKey,
        ImageUrl,
        MainSpecialtyNameEnglish,
        MainSpecialityKey,
        TopLevelEntityName,
        ExaminationRoomKey,
      } = item;

      const searchedIndex = searchList?.findIndex(
        itemObj =>
          `${itemObj.AccountKey}-${itemObj.ExaminationRoomKey}` ===
          `${AccountKey}-${ExaminationRoomKey}`,
      );

      list.push({
        isSelected: searchedIndex !== -1,
        fieldValue: `${DoctorNameEnglish}${TopLevelEntityName ? ` - ${TopLevelEntityName}` : ''}`,
        itemImage: ImageUrl,
        value: AccountKey,
        description: MainSpecialtyNameEnglish,
        key: AccountKey,
        extras: {
          AccountKey,
          BranchKey,
          BranchName,
          DoctorNameEnglish,
          EntityKey,
          ImageUrl,
          MainSpecialtyNameEnglish,
          MainSpecialityKey,
          TopLevelEntityName,
          ExaminationRoomKey,
        },
      });
    });
  }
  return list;
};
